import { useState, useEffect } from "react";

/**
 * Custom hook to manage the visibility of the JNJBar component.
 * It handles client-side state persistence using localStorage while avoiding SSR hydration issues.
 */
export const useJNJBar = (text: string): { showBar: boolean; onClickClose: () => void } => {
    // Default to `false` to ensure the server-rendered output and the initial
    // client-side render are identical. The bar will not be shown initially.
    const [showBar, setShowBar] = useState(false);

    const onClickClose = () => {
        try {
            // Persist the closed state to localStorage.
            localStorage.setItem("jnjBarIsClosed", "true");
        } catch (error) {
            // localStorage may not be available (e.g., private browsing, security settings)
            // eslint-disable-next-line no-console
            console.error("Failed to access localStorage:", error);
        }
        setShowBar(false);
    };

    useEffect(() => {
        let isClosed = false;
        try {
            isClosed = localStorage.getItem("jnjBarIsClosed") === "true";
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error("Failed to access localStorage:", error);
        }
        if (text && !isClosed) {
            setShowBar(true);
        } else {
            setShowBar(false);
        }
    }, [text]);

    return { showBar, onClickClose };
};
